import * as amplitude from '@amplitude/analytics-browser';
// 1. Пользователь открыл страницу (onboarding started)
const ampOnboardingStarted = () => {
  amplitude.track('onboarding started');
};

// 2. Пользователь выбрал пол
const ampGenderSelected = (gender) => {
  amplitude.track('gender_selected', { gender });
};

// 3. Пользователь попал на 2 экран
const amp2ndScreen = () => {
  amplitude.track('2nd screen');
};

// 4. Пользователь выбрал возраст
const ampAgeSelected = (age) => {
  amplitude.track('age_selected', { age });
};

// 5. Пользователь завершил экран
const ampScreenCompleted = (screen_id, title=null, input=null) => {
  amplitude.track('screen completed', {
    screen_id,
    title,
    input,
  });
};

// 6. Пользователь оставил email
const ampRegistration = () => {
  amplitude.track('registration');
};

// 7. Пользователь попал на страницу пейвола
const ampPaywall = (paywall_id) => {
  amplitude.track('paywall', { paywall_id });
};

// 8. Пользователь открыл попап с другими способами оплаты (не Apple Pay)
const ampCheckoutView = (plan, price, currency) => {
  amplitude.track('checkout view', {
    plan,
    price,
    currency,
  });
};

// 9. Пользователь кликнул по кнопке PayPal
const ampPaypalButtonClicked = (plan, price, currency, country) => {
  amplitude.track('paypal_button_clicked', {
    plan,
    price,
    currency
  });
};

// 10. Пользователь кликнул по кнопке Apple Pay
const ampApplePayUiOpened = (plan, price, currency) => {
  amplitude.track('apple_pay_ui_opened', {
    plan,
    price,
    currency,
  });
};

// 11. Пользователь оплатил подписку (браузерный Event)
const ampPurchase = ({currency, payment_method, price, productId, quantity}) => {
  amplitude.track('purchase', {
    currency,
    payment_method,
    price,
    productId,
    quantity,
  });
};

// 12. Пользователь зарегистрировался в приложении
const ampAppRegistration = (userId, email) => {
  amplitude.track('App registration', {
    userId,
    email,
  });
  amplitude.setUserId(userId);
};

// 13. Пользователь оплатил Upsale услугу
const ampPurchaseAdditional = ({currency, payment_method, price, productId, quantity}) => {
  amplitude.track('purchaseAditional', {
    currency,
    payment_method,
    price,
    productId,
    quantity,
  });
};

// 14. Пользователь перешел в стор для скачивания прилы
const ampAppDownloadClick = () => {
  amplitude.track('app download click');
};


// 14. Puschase статусы
const ampPurchaseStatus = (status, message="")=>{
  switch (status) {
    case 'started':
      amplitude.track('Purchase Started');
      break;
    case 'decline':
      amplitude.track('Purchase Decline',{
          "type" : message
        } 
      );
      break;
    case 'complete':
      amplitude.track('Purchase Complete');
      break;
    case 'UpsaleStarted':
      amplitude.track('Upsale Purchase Started');
      break;
    case 'UpsaleDecline':
      amplitude.track('Upsale Purchase Decline',{
          "type" : message
        } 
      );
      break;
    case 'UpsaleComplete':
      amplitude.track('Upsale Purchase Complete');
      break;
  }
  
}


export {
  ampPurchaseStatus,
  ampOnboardingStarted,
  ampGenderSelected,
  amp2ndScreen,
  ampAgeSelected,
  ampScreenCompleted,
  ampRegistration,
  ampPaywall,
  ampCheckoutView,
  ampPaypalButtonClicked,
  ampApplePayUiOpened,
  ampPurchase,
  ampAppRegistration,
  ampPurchaseAdditional,
  ampAppDownloadClick
}